import './clientportal-core.css';
import { b1 as setTag, b2 as captureMessage, b3 as captureException } from "./BrandedApp-CTnbfFkx.js";
import { b0, a$, $, b4, bb, bc, bd, b5, b6, w, i, be, bf, b, bg, b7, b8, b9, ba } from "./BrandedApp-CTnbfFkx.js";
const Sentry = {
  captureException,
  captureMessage,
  setTag
};
export {
  b0 as ClientPortalApps,
  Sentry,
  a$ as SwipeDirective,
  $ as addChatWidgetPositioningScript,
  b4 as getFirebaseAppInstance,
  bb as getSessionContactId,
  bc as getSessionCookieData,
  bd as getSessionCookies,
  b5 as handleServiceWorkerMessage,
  b6 as initializeApp,
  w as isAuthV2Enabled,
  i as isGokollab,
  be as isGokollabMobile,
  bf as isMobileOs,
  b as isPwa,
  bg as isWebKit,
  b7 as registerPushToken,
  b8 as requestNotificationPermission,
  b9 as sendNotificationToken,
  ba as validatePwaAuth
};
